import { render } from "./TraineeLogbookReport.vue?vue&type=template&id=9180c752&scoped=true"
import script from "./TraineeLogbookReport.vue?vue&type=script&lang=js"
export * from "./TraineeLogbookReport.vue?vue&type=script&lang=js"

import "./TraineeLogbookReport.vue?vue&type=style&index=0&id=9180c752&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9180c752"]])

export default __exports__